module.exports = __webpack_public_path__ + "static/media/Black Man Working on Analytics 1.5de2ade5.svg";